import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Sidebar = () => {
    const location = useLocation();
    const { user } = useAuth();

    const navItems = [
        { path: '/dashboard', icon: '📊', label: 'Dashboard' },
        { path: '/users', icon: '👥', label: 'Users' },
        { path: '/vendors', icon: '🏢', label: 'Vendors' },
        { path: '/stores', icon: '🏪', label: 'Stores' },
        { path: '/categories', icon: '🏷️', label: 'Categories' },
        { path: '/subcategories', icon: '🏷️', label: 'Subcategories' },
        { path: '/products', icon: '📦', label: 'Products' },
        { path: '/inventory', icon: '📊', label: 'Inventory' },
        { path: '/orders', icon: '📋', label: 'Orders' },
        { path: '/banners', icon: '🖼️', label: 'Banners' },
        // { path: '/variants', icon: '🔧', label: 'Variants' },
        { path: '/coupons', icon: '🎫', label: 'Coupons' },
    ];

    return (
        <div className="bg-white border-end" style={{ width: '250px', minHeight: '100vh' }}>
            <div className="p-4 border-bottom">
                <h4 className="text-success fw-bold mb-0">🛒 Golf Cart</h4>
                <small className="text-muted">Admin Panel</small>
            </div>

            <div className="p-3 border-bottom">
                <div className="d-flex align-items-center">
                    <div className="bg-success rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: '40px', height: '40px' }}>
                        <span className="text-white">{user?.username?.charAt(0)?.toUpperCase() || 'A'}</span>
                    </div>
                    <div className="ms-3">
                        <div className="fw-semibold">{user?.username || 'Admin'}</div>
                        <small className="text-muted">{user?.role || 'Super Admin'}</small>
                    </div>
                </div>
            </div>

            <Nav className="flex-column p-3">
                {navItems.map((item) => (
                    <Nav.Item key={item.path} className="mb-2">
                        <Link
                            to={item.path}
                            className={`nav-link d-flex align-items-center py-2 px-3 rounded ${location.pathname === item.path
                                ? 'bg-success text-white'
                                : 'text-dark hover-bg-light'
                                }`}
                            style={{ textDecoration: 'none' }}
                        >
                            <span className="me-3 fs-5">{item.icon}</span>
                            <span>{item.label}</span>
                        </Link>
                    </Nav.Item>
                ))}
            </Nav>
        </div>
    );
};

export default Sidebar;